import { MultiselectItem } from './types'
import { SELECT_ALL_ITEM } from './constants'

export const findSelectAllItem = (selectValues: MultiselectItem[]) =>
  !!selectValues.find((current) => current.value === SELECT_ALL_ITEM.value)
